import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=9b8b3a92&scoped=true&"
import script from "./EmailVerification.vue?vue&type=script&lang=js&"
export * from "./EmailVerification.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerification.vue?vue&type=style&index=0&id=9b8b3a92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8b3a92",
  null
  
)

export default component.exports